// Source: https://github.com/NerdWallet/nwjs-insurance-components/blob/master/src/input-us-address/lib/parse-address.ts
// Docs: https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult

type PlaceResult = google.maps.places.PlaceResult;

export type AddressGoogleResult = {
  streetNumber: string;
  streetName: string;
  city: string;
  state: string;
  zipCode: string;
};

export function parseGoogleAddress(
  googlePlace: PlaceResult,
): AddressGoogleResult {
  const { address_components: addressComponents } = googlePlace;
  const result = addressComponents.reduce(
    (inputs, input) => {
      if (input.types.includes('street_number')) {
        return {
          ...inputs,
          streetNumber: input.long_name,
        };
      }

      if (input.types.includes('route')) {
        return {
          ...inputs,
          streetName: input.long_name,
        };
      }

      if (input.types.includes('postal_code')) {
        return {
          ...inputs,
          zipCode: input.long_name,
        };
      }

      if (input.types.includes('sublocality')) {
        return {
          ...inputs,
          city: input.long_name,
        };
      }

      if (input.types.includes('locality')) {
        return {
          ...inputs,
          city: input.long_name,
        };
      }

      if (input.types.includes('administrative_area_level_1')) {
        return {
          ...inputs,
          state: input.short_name,
        };
      }

      return inputs;
    },
    {
      streetNumber: '',
      streetName: '',
      city: '',
      state: '',
      zipCode: '',
    },
  );

  return result;
}
